import {
  SEND_CALLBACKS,
  SEND_CALLBACKS_SUCCESS,
  SEND_CALLBACKS_ERROR,
} from "./actionTypes";

export const sendCallbacks = (user) => {
  return {
    type: SEND_CALLBACKS,
    payload: { user },
  };
};

export const sendCallbacksSuccess = (status, message) => {
  return {
    type: SEND_CALLBACKS_SUCCESS,
    payload: { status, message },
  };
};

export const sendCallbacksError = (msg) => {
  return {
    type: SEND_CALLBACKS_ERROR,
    payload: msg,
  };
};
